import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatMenuModule } from '@angular/material/menu';
import { ChatAttachment, ChatMessage } from 'cloud-shared-lib';
import { DateTime } from 'luxon';
import { Subject, takeUntil } from 'rxjs';
import { PipesModule } from '../../../pipes/pipes.module';
import { SupportChatService } from '../support-chat.service';

@Component({
  selector: 'csl-support-chat-message',
  templateUrl: './support-chat-message.component.html',
  standalone: true,
  imports: [CommonModule, PipesModule, MatChipsModule, MatIconModule, MatLegacyButtonModule, MatMenuModule],
})
export class SupportMessageComponent implements OnDestroy {
  @Input() messages: ChatMessage[];
  @Input() questionId: number;
  @Input() myId: string;

  @Output() retryMessageEvent = new EventEmitter<number>();
  @Output() cancelMessageEvent = new EventEmitter<number>();

  private unsubscribe$ = new Subject<void>();

  constructor(private supportChatService: SupportChatService) {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getTimeString(date: Date): string {
    const nowDate = DateTime.now();
    let messDate = DateTime.fromJSDate(new Date(date));
    messDate = messDate.minus({ hours: 3 });
    messDate = messDate.plus({ minutes: DateTime.local().offset });

    let formatString = 'HH:mm';

    if (messDate.year < nowDate.year) {
      formatString = 'DD.MM.YYYY';
    }

    if (messDate.month < nowDate.month) {
      formatString = 'DD MMMM';
    }

    if (messDate.day < nowDate.day) {
      formatString = 'DD.MM HH:mm';
    }

    return messDate.toFormat(formatString);
  }

  getAttachmentFile(questionId: number, messageId: number, attachment: ChatAttachment): void {
    this.supportChatService
      .getAttachmentFile(questionId, messageId, attachment.id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe();
  }

  isMyMessage(message: ChatMessage): boolean {
    return message.sendingId === this.myId;
  }
}
